import { FileServiceError } from "./FileServiceError";

export class FileServiceInvalidFileIdError extends FileServiceError {
  constructor(message: string) {
    super(message);
    Object.setPrototypeOf(this, new.target.prototype);
    this.name = "FileServiceInvalidFileIdErrorError";
  }
}
